import { render } from "./DayMealPlaceEditor.vue?vue&type=template&id=656f74b2"
import script from "./DayMealPlaceEditor.vue?vue&type=script&lang=js"
export * from "./DayMealPlaceEditor.vue?vue&type=script&lang=js"

import "./DayMealPlaceEditor.vue?vue&type=style&index=0&id=656f74b2&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__